export default {
    data: () => ({
        translations: {
            title: {
                el: "Εμφάνιση Πόντων Χρηστών",
                en: "Show User Points",
                it: "Mostra punti utente"
            },
            showUserPoints: {
                el: "Προβολή των πόντων των χρηστών στην εφαρμογή",
                en: "Show user points in the app",
                it: "Visualizzare i punti degli utenti nell'app"
            },
            yes: {
                el: "Ναι",
                en: "Yes",
                it: "Sì"
            },
            no: {
                el: "Όχι",
                en: "No",
                it: "No"
            }
        }
    })
};
